module.exports = __webpack_public_path__ + "img/search2.488989f3.png";